import { Container } from "@material-ui/core";
import React, { Fragment } from "react";
import { getToken } from "middleware/storage";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import GiftCardsHeader from "./header";
import GiftCardsContent from "./content";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";
import giftCardBanner from "assets/images/giftcard-banner.png";

export default function GiftCards() {
  useDocumentTitle(
    "Enterprise-Grade Gift Card Management | YOOZ",
    "Our flexible, browser-based platform is designed to help retailers of all sizes to launch, manage, and scale their gift card programmes. No complex hardware required."
  );

  const token = getToken();

  if (token) {
    return (
      <Container maxWidth="lg">
        <GiftCardsHeader />
        <GiftCardsContent />
      </Container>
    );
  }
  return (
    <Fragment>
      <PageBanner img={giftCardBanner} />
      <ContentWrapper>
        <GiftCardsHeader />
        <GiftCardsContent />
      </ContentWrapper>
    </Fragment>
  );
}
